import {
    vesselCategoriesByFleetTypeIds,
    vesselCategoriesByGasCbm,
} from '_legacy/modules/columns/vessel/models/VesselCategory';
import {
    DATASET_PCG,
    DATASET_LPG_VLGC,
    DATASET_LPG_MIDSIZE,
} from '_legacy/models/Datasets';

export const getVesselCategory = (vessel, datasetId) => {
    let vesselCategory = null;

    if (!vessel) {
        return null;
    }

    if (
        [DATASET_PCG, DATASET_LPG_VLGC, DATASET_LPG_MIDSIZE].includes(datasetId)
    ) {
        vesselCategory = vessel.gasCbm
            ? vesselCategoriesByGasCbm(vessel.gasCbm)
            : null;
    } else {
        vesselCategory = vessel.dwt
            ? vesselCategoriesByFleetTypeIds(datasetId, vessel.fleetTypeIds)
            : null;
    }

    return vesselCategory;
};
